import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties';

@Injectable({
  providedIn: 'root'
})
export class ApplicationlogsService {
  constructor(private httpClient: HttpClient, private route: Router) { }
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL + '/common';


  getgrid(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/applicationlogs/getgrid`, payload);
  }

  exceldownload() {
    return this.httpClient.post(`${this.baseURL}/applicationlogs/exceldownload`, { responseType: 'blob' });
  }

  getproductfilter(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/applicationlogs/getproductfilter/`, payload);
  }

  getorgfilter(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/applicationlogs/getorgfilter/`, payload);
  }

  closeLog(payload: any): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/applicationlogs/closelog`, payload);
  }

  getErrorOccurrences(payload: any) {
    return this.httpClient.post<any>(
      this.baseURL + '/applicationlogs/getErrorOccurrences',
      payload
    );
  }

  getDataByid(id: number): Observable<any> {
    return this.httpClient.get<any>(`${this.baseURL}/applicationlogs/getdatabyid/${id}`);
  }

  getSummaryCards() {
    return this.httpClient.post<any>(
      this.baseURL + '/applicationlogs/summary',
      {}
    );
  }
  getTopErrorSummary() {
    return this.httpClient.post(
      this.baseURL + '/applicationlogs/getTopErrorSummary',
      {}
    );
  }
  getclosedbyfilter(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/applicationlogs/getclosedbyfilter/`, payload);
  }

  getDashboardCharts(payload: any) {
    return this.httpClient.post(`${this.baseURL}/applicationlogs/getcharts/`, payload);
  }

  getLogsByProduct(payload: any) {
    return this.httpClient.post(`${this.baseURL}/applicationlogs/getlogsbyproduct/`, payload);
  }

  requestChartReload(payload: any) {
    return this.httpClient.post(`${this.baseURL}/applicationlogs/requestchartreload/`, payload);
  }
  getRandomInsight() {
    return this.httpClient.post<any>(
      this.baseURL + '/applicationlogs/randominsights',
      {}
    );
  }

  getReminderHistory(logid): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/applicationlogs/getreminderhistory/${logid}`);
  }
  getTechUsers(): Observable<any[]> {
    return this.httpClient.get<any[]>(
      `${this.baseURL}/applicationlogs/gettechusers`
    );
  }

  remindUser(payload: any): Observable<Object> {
    return this.httpClient.post(`${this.baseURL}/applicationlogs/reminduser`, payload);
  }
  

  getErrorOccurenceInLogClosure(logid): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/applicationlogs/geterroroccurenceinlogclosure/${logid}`);
  }

  getActivityFeed(payload: any): Observable<any[]> {
    return this.httpClient.post<any[]>(`${this.baseURL}/applicationlogs/getactivityfeed`,payload);
  }

}
